import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  BusinessPersonWithTrainingSkeleton,
  BusinessPersonTrainingRequirementAudit
} from '../../+models/training-requirement-audit.model';

@Component({
  selector: 'sd-portal-staff-member-list',
  templateUrl: './staff-member-list.component.html',
  styleUrls: ['./staff-member-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StaffMemberListComponent implements OnInit {
  @Input() businessPersonWithTrainingSkeletons: BusinessPersonWithTrainingSkeleton[];
  @Input() loading: boolean;
  @Input() audits: BusinessPersonTrainingRequirementAudit[];

  @Output() opened = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  onOpened(businessPersonTrainingRequirementId: number) {
    this.opened.emit(businessPersonTrainingRequirementId);
  }

  onNextPage(businessPersonTrainingRequirementId: number) {
    this.nextPage.emit(businessPersonTrainingRequirementId);
  }
}
